/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import Grid from "@material-ui/core/Grid";

import * as S from "./styles";

export interface IHeaderProps {
  headerContent?: any;
}

export const Header = ({ headerContent }: IHeaderProps) => {
  return (
    <>
      <div
        className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4"
        style={S.headerContainerStyle}
      >
        <Grid container justifyContent="space-around" alignItems="stretch">
          <Grid item sm={5} xs={12}>
            <div style={S?.columnHeaderStyle}>
              {headerContent?.leftColumnHeader}
            </div>
          </Grid>
          <Grid item sm={5} xs={12}>
            {" "}
            <div style={S?.columnHeaderStyle}>
              {headerContent?.rightColumnHeader}
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

Header.defaultProps = {};
